/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	/**
	 * @interface DashboardPreferencesAPI
	 * @hideconstructor
	 * @classdesc API class that is used to manage user preferences.
	 * @example dashboard.getFeature('DashboardPreferences')
	 */
	class DashboardPreferencesAPI {
		/**
		 * @description Returns an attribute that was set in the preferences.
		 * @param {string} name Name of the preference
		 * @return {(string|boolean|number|null|undefined)} Value of the preference; null means the property will be removed when saved.
		 */
		getPreference() {}

		/**
		 * @description Sets the preference.
		 * @param {string} name Name of the preference
		 * @param {(string|boolean|number|null)} value Value of the preference to set; exception is thrown when it is not one of these types.
		 */
		setPreference() {}

		/**
		 * @description Saves the preferences.
		 * @returns {Promise} Promise is rejected if the save did not complete successfully.
		 */
		savePreferences() {}
	}
	return DashboardPreferencesAPI;
});
